<template>
  <div style="padding: 5px; text-align: right">
    <div class="filter-group">
      <b-field label="Select date or status for search order">
        <div class="filter">
          <b-datepicker
            size="is-small"
            :max-date="new Date()"
            placeholder="Select date"
            v-model="startTime"
            range
          >
          </b-datepicker>
        </div>
        <div class="filter">
          <b-select size="is-small" placeholder="Select status" v-model="statusSelected">
            <option v-for="option in status" :value="option" :key="option">
              {{ option }}
            </option>
          </b-select>
        </div>
        <div class="filter">
          <b-select size="is-small" placeholder="Select branch" v-model="branchSelected">
            <option v-for="option in branchs" :value="option.name" :key="option.name">
              {{ option.name }}
            </option>
          </b-select>
        </div>
      </b-field>

      <b-field label="Filter">
        <b-button type="is-primary is-light" @click="onFilterData" size="is-small">
          <b-icon pack="fas" icon="search" size="is-medium" type="is-primary is-light"> </b-icon>
        </b-button>
      </b-field>
      <b-field label="Clear">
        <b-button type="is-danger is-light" @click="onClearFilter" size="is-small">
          <b-icon pack="fas" icon="close" size="is-medium" type="is-danger is-light"> </b-icon>
        </b-button>
      </b-field>
    </div>

    <div class="filter-group">
      <b-field label="Search order" style="width: 100%">
        <div class="filter" style="display: flex; gap: 0.5rem">
          <b-input
            style="width: 100%; max-width: 300px"
            @keydown.enter.native="onSearchOrder"
            v-model="orderID"
            size="is-small"
            placeholder="Order ID"
          ></b-input>
          <b-button type="is-primary is-light" @click="onSearchOrder" size="is-small">
            <b-icon pack="fas" icon="search" size="is-medium" type="is-primary is-light"> </b-icon>
          </b-button>
          <b-button type="is-danger is-light" @click="onClearSearchResult" size="is-small">
            <b-icon pack="fas" icon="close" size="is-medium" type="is-danger is-light"> </b-icon>
          </b-button>
        </div>
        <!-- <div class="filter">
          <b-select size="is-small" placeholder="Select branch" v-model="branchSelected">
            <option v-for="option in branchs" :value="option.name" :key="option.name">
              {{ option.name }}
            </option>
          </b-select>
        </div> -->
      </b-field>
    </div>
  </div>
</template>

<script>
import branchs from "@/settings/branchs";
import { statusByRouteName } from "@/settings/orderStatus";
export default {
  props: {
    orderLimit: Number,
  },
  data() {
    return {
      filter: false,
      orderID: null,
      branchs: branchs,
      // status: status,
      startTime: new Date(),
      endTime: null,
      statusSelected: "ALL",
      branchSelected: null,
      hourFormat: "24",
    };
  },
  computed: {
    status() {
      return statusByRouteName[this.$route.name] ?? [];
    },
  },
  watch: {
    $route() {
      this.orderID = null;
      this.branchSelected = null;
      this.startTime = new Date();
      this.endTime = null;
      this.statusSelected = "ALL";
      this.clearSearchOrderData();
    },
  },
  methods: {
    async onFilterData() {
      this.clearSearchOrderData();

      this.endTime = this.startTime[1];
      let date = this.startTime[0];

      this.$store.commit("orders/setSelectedStatus", this.statusSelected);
      this.$store.commit("orders/setEmptyOrders");

      this.$store.commit("orders/setLoadingOrder", false);

      if (this.statusSelected === "ALL") {
        let orderLimit = 10;

        if (this.orderLimit > orderLimit) {
          orderLimit = this.orderLimit;
        }

        console.log("onFilterData: ", orderLimit);

        const filter = {
          // id: this.orderID,
          origin: this.branchSelected,
          date: date,
          endTime: this.endTime,
          orderLimit: orderLimit,
        };

        await Promise.all([
          this.$store.dispatch("orders/getOrdersWithFilter", {
            status: "FINDDRIVER",
            ...filter,
          }),
          this.$store.dispatch("orders/getOrdersWithFilter", {
            status: "CANCELBYADMIN",
            ...filter,
          }),
          this.$store.dispatch("orders/getOrdersWithFilter", {
            status: "CANCELBYDRIVER",
            ...filter,
          }),
          this.$store.dispatch("orders/getOrdersWithFilter", { status: "PROGRESS", ...filter }),
          this.$store.dispatch("orders/getOrdersWithFilter", { status: "PICKUP", ...filter }),
          this.$store.dispatch("orders/getOrdersWithFilter", { status: "DELIVERING", ...filter }),
          this.$store.dispatch("orders/getOrdersWithFilter", { status: "SUCCESS", ...filter }),
          // for lalamove
          this.$store.dispatch("lalamove/getOrdersByStatusDeliveryDateLalamove", {
            status: "COMPLETED",
            sTime: date,
            nTime: this.endTime,
          }),
          //
        ]);
      } else {
        await this.$store.dispatch("orders/getOrdersWithFilter", {
          // id: this.orderID,
          origin: this.branchSelected,
          status: this.statusSelected,
          date: date,
          endTime: this.endTime,
        });
      }

      this.$store.commit("orders/setLoadingOrder", true);
    },
    async onClearFilter() {
      this.$store.commit("orders/setLoadingOrder", false);

      this.$store.commit("orders/setSelectedStatus", "ALL");
      this.$store.commit("orders/setEmptyOrders");
      // for lalamove
      this.$store.commit("lalamove/setEmptyOrdersOnFilter");
      //

      this.clearSearchOrderData();

      await Promise.all([
        this.$store.dispatch("orders/getOrders", { status: "FINDDRIVER" }),
        this.$store.dispatch("orders/getOrders", { status: "CANCELBYADMIN" }),
        this.$store.dispatch("orders/getOrders", { status: "CANCELBYDRIVER" }),
        this.$store.dispatch("orders/getOrders", { status: "PROGRESS" }),
        this.$store.dispatch("orders/getOrders", { status: "PICKUP" }),
        this.$store.dispatch("orders/getOrders", { status: "DELIVERING" }),
        this.$store.dispatch("orders/getOrders", { status: "SUCCESS" }),
      ]);
      this.branchSelected = null;
      this.startTime = new Date();
      this.endTime = null;
      this.statusSelected = "ALL";

      this.$store.commit("orders/setLoadingOrder", true);
    },
    clearSearchOrderData() {
      this.orderID = null;
      this.$store.commit("orders/setSearchResult", null);
      this.$store.commit("orders/setSearchErrorMessage", null);
    },
    onClearSearchResult() {
      this.clearSearchOrderData();
    },
    async onSearchOrder() {
      console.log("onSearchOrder", this.orderID);
      const trimedOrderId = this.orderID.trim();
      if (!trimedOrderId) {
        return;
      }
      try {
        this.$store.commit("orders/setSearchResult", null);
        this.$store.commit("orders/setSearchErrorMessage", null);
        this.$store.commit("orders/setSearchOrderLoading", true);
        const order = await this.$store.dispatch("orders/getSingleOrder", trimedOrderId);
        const allowedStatus = statusByRouteName[this.$route.name];
        const isAllowed = allowedStatus.includes(order?.status);
        if (order && isAllowed) {
          const computedOrder = this.computeOrder(order);
          console.log("onSearchOrder response", order, computedOrder);
          this.$store.commit("orders/setSearchResult", computedOrder);
        } else {
          const message = `ไม่พบคำสั่งซื้อหมายเลข ${trimedOrderId}`;
          this.$store.commit("orders/setSearchErrorMessage", message);
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.$store.commit("orders/setSearchOrderLoading", false);
      }
    },
    computeOrder(order) {
      const date = order.date?.date ?? "Unknown";
      const status = order.date?.status?.status ?? "Unknown";

      const items = [order];
      const statusObject = {
        items,
        priority: 1,
      };

      let dateObject = {};
      dateObject[status] = statusObject;

      let orderObject = {};
      orderObject[date] = dateObject;

      return orderObject;
    },
  },
};
</script>

<style scoped>
.filter-group {
  background-color: white;
  padding: 0 10px;
  flex-direction: row;
  display: flex;
  text-align: left;
  /* overflow: scroll; */
}
.filter {
  padding: 2px;
}
.field {
  padding: 0 3px;
  margin: 0px;
}
>>> .label {
  font-size: 12px;
  padding-top: 10px;
}
</style>
<style>
.b-tooltip.is-multiline.is-medium .tooltip-content {
  width: 500px;
}
</style>
